import { ManufacturerProductPropertyDetail } from '@deltek/specification-client/core/Models/product'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Divider, makeStyles, Theme, Typography } from '@material-ui/core'
import clsx from 'clsx'
import React, { FC, Fragment } from 'react'
import { SupportedOptionsObject } from '../ListingDetailsPage'
import OptionGroups from './OptionGroups'
import { Propertyname } from './Propertyname'

import colors from '../../listingColors'

const { propertiesDivider } = colors

interface PropertySectionProps {
    propertyName: string
    property: Partial<ManufacturerProductPropertyDetail>[]
    hasDivider?: boolean
    mode: string
    selectedData: SupportedOptionsObject
}

const useStyles = makeStyles((theme: Theme) => ({
    propContent: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        wordBreak: 'break-word',
    },
    content: {
        marginTop: theme.spacing(1.5),
    },
    subPropertyName: {
        fontSize: pxToRem(13),
    },
    divider: {
        backgroundColor: propertiesDivider,
        marginBottom: theme.spacing(1),
    },
    optionGroups: { paddingLeft: theme.spacing(1) },
}))

const PropertySection: FC<PropertySectionProps> = ({
    propertyName,
    property,
    hasDivider,
    mode,
    selectedData,
}) => {
    const classes = useStyles()
    return (
        <GridItem xs={12}>
            <GridContainer>
                <Propertyname propertyName={propertyName} />
                {property.map(
                    ({
                        propertyId,
                        subPropertyName = '',
                        optionGroups,
                        isPremiumPlus,
                    }) => {
                        if (
                            isPremiumPlus &&
                            !selectedData[propertyName][subPropertyName].length
                        ) {
                            return <Fragment key={propertyId} />
                        }

                        return (
                            <GridItem
                                className={clsx(
                                    classes.content,
                                    classes.propContent
                                )}
                                xs={12}
                                key={propertyId}
                            >
                                <GridContainer>
                                    <GridItem md={3}>
                                        <Typography
                                            component="span"
                                            className={classes.subPropertyName}
                                        >
                                            {subPropertyName}:
                                        </Typography>
                                    </GridItem>
                                    <GridItem
                                        md={9}
                                        className={classes.optionGroups}
                                    >
                                        {optionGroups?.map(
                                            ({
                                                groupId,
                                                prefix,
                                                postfix,
                                                options,
                                            }) => (
                                                <OptionGroups
                                                    key={groupId}
                                                    groupId={groupId}
                                                    prefix={prefix ?? ''}
                                                    options={options ?? []}
                                                    propertyName={propertyName}
                                                    subPropertyName={
                                                        subPropertyName ?? ''
                                                    }
                                                    postfix={postfix ?? ''}
                                                    mode={mode}
                                                    selectedData={
                                                        !!selectedData
                                                            ? selectedData
                                                            : {}
                                                    }
                                                    propertyId={propertyId}
                                                />
                                            )
                                        )}
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        )
                    }
                )}
            </GridContainer>
            {hasDivider && <Divider classes={{ root: classes.divider }} />}
        </GridItem>
    )
}

export default PropertySection
